module.exports = __webpack_public_path__ + "static/media/roundTwo.4f80457c.png";